import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useDocumentsType } from '../../hooks/useDocumentsType';
import DocumentsTypeDashboard from '../../components/administracion/DocumentsTypeDashboard.js';

const TipoDocumentosPage = () => {
  const { documentsType, error, isLoading } = useDocumentsType();

  if (isLoading) return <CircularProgress />;
  if (error) return <Alert severity="error">Error al cargar tipo de documentos.</Alert>;

  return (
    <Box sx={{ p: 2 }}>
      <DocumentsTypeDashboard
        windows={documentsType}
        onReorder={(newOrder) => {
          console.log('Nuevo orden de tipo de documentos:', newOrder);
        }}
      />
    </Box>
  );
};

export default TipoDocumentosPage;